import './hs-form-search.min'

let timer
let last_search = ''

globalThis.poptastic = poptastic

function poptastic(url) {
  window.open(url, 'open_dialog', 'width=800,height=600')
}

document.addEventListener('turbo:load', function () {
  $(document).on('click', '.chat-main-container', function () {
    $('.chat-main-container').css('z-index', '')
    $(this).css('z-index', '1')
  })
  $(document).on('keydown', 'input', function (e) {
    if (e.key === ' ' && this.value.length === 0) {
      e.preventDefault()
    }
  })

  $('.post-form ').on('click', function (e) {
    $('#post-form').hide()
    $('#post_section').removeClass('d-none').show()
    $('.post-field').focus()
    let btn = document.getElementById(`${e?.target?.dataset?.element}`)
    if (btn) {
      setTimeout(() => {
        btn.click()
      }, 100)
    }
  })

  $(document).on('keyup', '#body-field', function () {
    length = $(this).val().length
    $(this).closest('.post-form').find('#body-count').html(length)
  })

  $('.rack-search').keyup(function () {
    if ($('.rack-search').val() == '') {
      $('.hs-form-search-menu-content').addClass('hs-form-search-menu-hidden')
    } else {
      $('.hs-form-search-menu-content').removeClass(
        'hs-form-search-menu-hidden'
      )
      $('.hs-form-search-menu-content').addClass(
        'hs-form-search-menu-initialized w-100'
      )
      clearTimeout(timer)
      if (last_search != $(this).val()) {
        timer = setTimeout(() => {
          last_search = $(this).val()
          rack_searching($(this).val())
        }, 500)
      }
    }
  })

  $(document).on('click', '.copy-profile-link', async function (e) {
    e.preventDefault()
    try {
      await navigator.clipboard.writeText(globalThis.location.href)

      Swal.fire({
        customClass: {
          popup:
            'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        html: 'Copied.',
        showCloseButton: true,
        buttonsStyling: false,
        showConfirmButton: false,
        timer: 2000
      })
    } catch (err) {
      console.error('Copy failed', err)
    }
  })

  $('.select_card').change(function () {
    if ($(this).is(':checked')) {
      let selectedId = $(this).data('id')
      $('#edit_card').removeClass('disabled')
      $('#edit_card').removeAttr('data-turbo-frame')
      $('#edit_card').attr(
        'href',
        '/user_cards/' + selectedId + '/edit?new_wallet=true'
      )
      $('#remove_card').removeClass('disabled')
      $('#remove_card').attr('href', '/user_cards/' + selectedId)
    }
  })

  $('.select_bank').change(function () {
    if ($(this).is(':checked')) {
      let selectedId = $(this).data('id')
      $('#edit_card').removeClass('disabled')
      $('#edit_card').attr('data-turbo-frame', 'scroll_modal_content')
      $('#edit_card').attr(
        'href',
        '/user_bank_accounts/' + selectedId + '/edit'
      )
      $('#remove_card').removeClass('disabled')
      $('#remove_card').attr('href', '/user_bank_accounts/' + selectedId)
    }
  })

  $(document).on(
    'click',
    '.sorting_data, .all_data, .select_country',
    function (e) {
      $('.sorting_data, .all_data, .select_country').removeClass(
        'promoted_active'
      )
      $(this).addClass('promoted_active')
    }
  )

  const moreMenu = document.getElementById('navbarVerticalHelpDeskMenu')
  const offcanvasBody = document.querySelector('.offcanvas-body')

  if (!moreMenu || !offcanvasBody) return

  function smoothScrollToBottom(duration = 100) {
    const start = offcanvasBody.scrollTop
    const end = offcanvasBody.scrollHeight - offcanvasBody.clientHeight
    const distance = end - start

    if (distance <= 0) return

    let startTime = null

    function animation(currentTime) {
      if (!startTime) startTime = currentTime
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      offcanvasBody.scrollTop = start + distance * easeInOut(progress)

      if (elapsed < duration) {
        requestAnimationFrame(animation)
      }
    }

    requestAnimationFrame(animation)
  }

  moreMenu.addEventListener('shown.bs.collapse', () => {
    // wait for Bootstrap collapse animation to finish
    setTimeout(() => {
      smoothScrollToBottom(800) // ⬅️ 2 seconds
    }, 300)
  })

  jQuery('.slot_available_time').click(function () {
    let id = jQuery(this).attr('id')
    jQuery('input[name="' + id + '"]').trigger('click')
  })

  function resetCardActions() {
    $('#edit_card').addClass('disabled').removeAttr('href')
    $('#remove_card').addClass('disabled').removeAttr('href')
  }

  $(document).on('card:reset', function () {
    resetCardActions()
  })

  $('#analytics').on('change', () => {
    const value = event.target.value
    const url = `/${event.target.dataset.url}?range=${value}`

    Turbo.visit(url, { frame: 'analytics_frame' })
  })

  $('#analytics_bar select').on('change', () => {
    const status = $('#analytics-bar-status').val()
    const year = $('#analytics-bar-details').val()
    const url = `/${event.target.dataset.url}?year=${year}&status=${status}`
    Turbo.visit(url, { frame: 'analytics_bar' })
  })
})

globalThis.customSharePopup = customSharePopup

function easeInOut(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
}

function customSharePopup(url, type, id, classes) {
  window.open(url, 'share_dialog', 'width=626,height=450')
}

function rack_searching(search_txt) {
  fetch('/libraries/search_rack?search=' + search_txt, {
    method: 'get',
    headers: {
      Accept: 'text/vnd.turbo-stream.html'
    }
  })
    .then((r) => r.text())
    .then((html) => {
      Turbo.renderStreamMessage(html)
      formSearch.loading(false)
    })
}

document.addEventListener('DOMContentLoaded', function () {
  const backButton = document.querySelector('.replace-state')
  if (backButton) {
    backButton.addEventListener('click', function () {
      globalThis.location.replace('/')
    })
  }
})

document.addEventListener('wheel', function (event) {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur()
  }
})

function removeElement() {
  $('#clearIconLoadingEgBlack').click()
}

document.addEventListener('turbo:load', function () {
  const loader = document?.querySelector('[data-turbo-preview]')
  if (loader) delete loader.dataset.turboPreview
})

function alert(message, timer = 3000) {
  Swal.fire({
    customClass: {
      popup:
        'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
      htmlContainer: 'text-black-paint text-white'
    },
    animation: false,
    html: message,
    icon: 'error',
    showCloseButton: true,
    buttonsStyling: false,
    showConfirmButton: false,
    timer: timer
  })
}

async function confirmFileRemoval(
  message = 'Are you sure you want to remove this file?'
) {
  const result = await Swal.fire({
    customClass: {
      popup:
        'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
      htmlContainer: 'text-black-paint text-white'
    },
    animation: false,
    title: 'Confirmation',
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Remove',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#d56859'
  })

  return result.isConfirmed
}

function markRead(target) {
  document?.getElementById(target)?.classList.add('opacity-0')
}

globalThis.alert = alert
globalThis.removeElement = removeElement
globalThis.markRead = markRead
globalThis.confirmFileRemoval = confirmFileRemoval
